/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticle } from './APIArticle';
import {
    APIArticleFromJSON,
    APIArticleFromJSONTyped,
    APIArticleToJSON,
} from './APIArticle';

/**
 * 
 * @export
 * @interface APIPaginatedArticleList
 */
export interface APIPaginatedArticleList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedArticleList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedArticleList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedArticleList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIArticle>}
     * @memberof APIPaginatedArticleList
     */
    results: Array<APIArticle>;
}

/**
 * Check if a given object implements the APIPaginatedArticleList interface.
 */
export function instanceOfAPIPaginatedArticleList(value: object): value is APIPaginatedArticleList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedArticleListFromJSON(json: any): APIPaginatedArticleList {
    return APIPaginatedArticleListFromJSONTyped(json, false);
}

export function APIPaginatedArticleListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedArticleList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIArticleFromJSON)),
    };
}

export function APIPaginatedArticleListToJSON(value?: APIPaginatedArticleList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIArticleToJSON)),
    };
}

